<template>
  <v-card class="result-not-found-card" elevation="0">
    <v-card-text class="text-center">
      <img
        :src="require('@/assets/img/blognotfound.svg')"
        alt="No result found illustration"
        class="not-found-image"
      />
      <h2 class="not-found-title">{{ title }}</h2>
      <p class="search-hint">{{ hint }}</p>
      <v-btn class="search-again-button" color="#007AB2" @click="searchAgain">
        Search again
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { useRouter } from 'vue-router';

// Define props
const props = defineProps({
  searchQuery: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: 'No result found',
  },
  hint: {
    type: String,
    default: 'Please try again with another keywords or maybe use generic term',
  },
});

// Define emits
const emit = defineEmits(['clearSearchInput']);

// Router for navigation
const router = useRouter();

// Handle search again action
const searchAgain = () => {
  emit('clearSearchInput'); // Emit event to clear search input

  // Navigate to the parent route (assuming HeroSection is on the same page)
  router.push({
    path: router.currentRoute.value.path,
    hash: '#search-container',
  });

  // Wait for navigation and DOM update, then focus on search input
  setTimeout(() => {
    const searchInput = document.getElementById('search-input');
    if (searchInput) {
      searchInput.focus();
    }
  }, 100);
};
</script>

<style scoped>
.result-not-found-card {
  max-width: 600px;
  margin: 40px auto;
  background: transparent;
}

.not-found-image {
  max-width: 300px;
  width: 100%;
  margin-bottom: 20px;
}

.not-found-title {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
}

.search-again-button {
  margin-top: 1rem;
  color: white !important;
  text-transform: none;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 8px;
  height: 45px;
}

@media (max-width: 600px) {
  .not-found-image {
    max-width: 200px;
  }

  .not-found-title {
    font-size: 1.2em;
  }

  .search-again-button {
    width: 100%;
  }
}
</style>